import { render } from "./FullMainMenu.vue?vue&type=template&id=fcfa4c12"
import script from "./FullMainMenu.vue?vue&type=script&lang=js"
export * from "./FullMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__